import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { BaseService } from '../base.service';


@Injectable()
export class FixedPriceService extends BaseService<any>{
    constructor(public httpClient: HttpClient) {
        super(
            'fixedSearch',
            httpClient);
    }

 private readonly trIpRanges: Array<[number, number]> = [
    // 31'li, 37'li ve 46'lı Bloklar (Turkcell, Superonline, TT, Vodafone)
    [this.ipToLong('31.44.192.0'), this.ipToLong('31.44.207.255')],
    [this.ipToLong('31.145.0.0'), this.ipToLong('31.145.255.255')],
    [this.ipToLong('31.206.0.0'), this.ipToLong('31.207.255.255')],
    [this.ipToLong('37.130.0.0'), this.ipToLong('37.131.255.255')],
    [this.ipToLong('37.154.0.0'), this.ipToLong('37.155.255.255')],
    [this.ipToLong('46.1.0.0'), this.ipToLong('46.2.255.255')],
    [this.ipToLong('46.196.0.0'), this.ipToLong('46.197.255.255')],
    [this.ipToLong('46.221.0.0'), this.ipToLong('46.221.255.255')],

    // 5'li ve 62'li Bloklar
    [this.ipToLong('5.11.128.0'), this.ipToLong('5.11.255.255')],
    [this.ipToLong('5.44.80.0'), this.ipToLong('5.44.95.255')],
    [this.ipToLong('5.226.192.0'), this.ipToLong('5.226.255.255')],
    [this.ipToLong('62.248.0.0'), this.ipToLong('62.248.127.255')],

    // 78'li Bloklar (SENİN IP'N BURADA: Türk Telekom ADSL/VDSL/Fiber)
    [this.ipToLong('78.160.0.0'), this.ipToLong('78.191.255.255')],

    // 81'li, 82'li, 85'li, 88'li Bloklar (TTNET, Superonline, Türksat KabloNet)
    [this.ipToLong('81.212.0.0'), this.ipToLong('81.215.255.255')],
    [this.ipToLong('82.222.0.0'), this.ipToLong('82.223.255.255')],
    [this.ipToLong('85.96.0.0'), this.ipToLong('85.110.255.255')],
    [this.ipToLong('88.224.0.0'), this.ipToLong('88.255.255.255')],

    // 94'lü ve 95'li Bloklar (Türk Telekom, Vodafone, TurkNet)
    [this.ipToLong('94.54.0.0'), this.ipToLong('94.55.255.255')],
    [this.ipToLong('94.120.0.0'), this.ipToLong('94.123.255.255')],
    [this.ipToLong('95.0.0.0'), this.ipToLong('95.15.255.255')],
    [this.ipToLong('95.183.0.0'), this.ipToLong('95.183.255.255')],

    // 176, 178, 185, 188 Blokları (Mobil, Fiber ve Hosting)
    [this.ipToLong('176.40.0.0'), this.ipToLong('176.43.255.255')],
    [this.ipToLong('176.232.0.0'), this.ipToLong('176.240.255.255')],
    [this.ipToLong('178.233.0.0'), this.ipToLong('178.251.255.255')],
    [this.ipToLong('185.29.184.0'), this.ipToLong('185.29.187.255')],
    [this.ipToLong('185.90.0.0'), this.ipToLong('185.96.255.255')],
    [this.ipToLong('188.3.0.0'), this.ipToLong('188.58.255.255')],

    // 193'lü, 195'li, 212'li, 213'lü, 217'li Bloklar (Kurumsal, Kamu, ISP Havuzları)
    [this.ipToLong('193.140.0.0'), this.ipToLong('193.140.255.255')], // ULAKBİM / Üniversiteler
    [this.ipToLong('195.175.0.0'), this.ipToLong('195.175.255.255')], // TTNET DNS & Kurumsal
    [this.ipToLong('212.156.0.0'), this.ipToLong('212.175.255.255')],
    [this.ipToLong('213.14.0.0'), this.ipToLong('213.14.255.255')],
    [this.ipToLong('213.74.0.0'), this.ipToLong('213.75.255.255')],
    [this.ipToLong('217.131.0.0'), this.ipToLong('217.131.255.255')]
  ];

  /**
   * IP adresini (örn: "85.96.12.1") kıyaslama kolaylığı için 32-bit sayıya çevirir.
   */
  private ipToLong(ip: string): number {
    return ip.split('.').reduce((acc, octet) => (acc << 8) + parseInt(octet, 10), 0) >>> 0;
  }

  /**
   * Verilen IP adresinin Türkiye IP bloklarında olup olmadığını kontrol eder.
   */
  private isTrIp(ip: string): boolean {
    const userIpLong = this.ipToLong(ip);
    return this.trIpRanges.some(([start, end]) => userIpLong >= start && userIpLong <= end);
  }


    searchFixedPrices(params): Observable<any[]> {
        let uri = new URL(environment.baseUrl + `/public/fixedSearch/byCountryCode`).updateQueryParam(params);

        return this.httpClient.get<any[]>(uri.toString(), { withCredentials: false, headers: this.httpHeaders() })
            .pipe(
                tap(),
                catchError(this.handleError)
            )
    }
    searchPricesByCode(params): Observable<any[]> {
        let uri = new URL(environment.baseUrl + `/public/fixedSearch/searchByCountryCode`).updateQueryParam(params);

        return this.httpClient.get<any[]>(uri.toString(), { withCredentials: false, headers: this.httpHeaders() })
            .pipe(
                tap(),
                catchError(this.handleError)
            )
    }

    searchDashboardPricesByCode(): Observable<any[]> {
        let uri = new URL(environment.baseUrl + `/dashboardFixedPrice`);

        return this.httpClient.get<any>(uri.toString(), { withCredentials: false, headers: this.httpHeaders() })
            .pipe(
                tap(),
                catchError(this.handleError)
            )
    }

  async getIpLocation(isSecure: boolean = false): Promise<{ countryCode: string; query?: string }> {
    try {
      // Sadece kullanıcının IP adresini almak için ücretsiz ve hızlı apiify servisini kullanıyoruz
      const protocol = isSecure ? 'https' : 'http';
      const response = await fetch(`${protocol}://api.ipify.org?format=json`);
      const data = await response.json();
      
      const userIp: string = data.ip;
      const isTurkey = this.isTrIp(userIp);

      console.log(data, isTurkey)
      return {
        countryCode: isTurkey ? 'TR' : 'XX',
        query: userIp
      };
    } catch (error) {
      // İstek başarısız olursa (örn. adblocker) varsayılan olarak TR dışı kabul eder
      return { countryCode: 'XX' };
    }
  }

     getDiscountSegment(): Observable<any[]> {
        let uri = new URL(environment.baseUrl + `/dashboardFixedPrice/discountSegment`);

        return this.httpClient.get<any>(uri.toString(), { withCredentials: false, headers: this.httpHeaders() })
            .pipe(
                tap(),
                catchError(this.handleError)
            )
    }


}
